import { sendWebsocketMessage } from '../../../../../App';

export function cancelOrder(order){
  const msg = {
    messageType: 'cancelOrder',
    orderInfo: {
      brokerage: order.brokerage,
      accountId: order.accountId,
      orderId: order.id
    }
  };
  sendWebsocketMessage(msg);
}


